import { tuApptoAPI, getAuthHeaders, getErrorData } from './config'

const headers = getAuthHeaders().headers
export const findAll = async id => {
  try {
    const response = await tuApptoAPI.get(`/reserves/findall/${id}`, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const historic = async id => {
  try {
    const response = await tuApptoAPI.get(`/reserves/historic/${id}`, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const disabled = async request => {
  try {
    const response = await tuApptoAPI.post('/reserves/disabled', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const turns = async request => {
  try {
    const response = await tuApptoAPI.post('/reserves/turns/available', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const create = async request => {
  try {
    const response = await tuApptoAPI.post('/reserves/create', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const status = async request => {
  try {
    const response = await tuApptoAPI.post('/reserves/status', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const remove = async id => {
  try {
    const response = await tuApptoAPI.delete(`/reserves/delete/${id}`, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}
